import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import twitterlogo from "./Images/twitter-logo.png";
import fblogo from "./Images/fb-logo.png";
import instalogo from "./Images/insta-logo.png";
import icons8hamburger from "./Images/icons8-hamburger-menu-24.png";
import { Menu } from "@mui/material";
import { IconButton } from "@mui/material";
import Example from "./NavDropdown";

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`w-full fixed top-0 z-10 bg-[#EDFEFF] ${
        isScrolled ? "shadow-md bg-white z-10" : ""
      }`}
    >
      <div
        className="flex h-20 flex-row justify-between items-center max-[640px]:gap-2"
        style={{ paddingTop: "12px", marginBottom: "12px" }}
      >
        <div className="pl-10">
          <Link to={"/"}>
            <img
              src="/newimage/logoenglish.png"
              className="lg:ml-20 w-24 h-[90px]"
              alt="Logo"
            />
          </Link>
        </div>

        <div className="flex lg:cols-span-1 gap-[60px] mx-auto">
          <Link
            className="text-[16px] text-stone-500 font-semibold hover:text-blue-400 max-lg:hidden"
            to="/"
          >
            Home
          </Link>
          <Link
            className="text-[16px] text-stone-500 font-semibold hover:text-blue-400 max-lg:hidden"
            to="/about"
          >
            About Us
          </Link>
          <Example />
          <Link
            className="text-[16px] text-stone-500 font-semibold hover:text-blue-400 max-lg:hidden"
            to="/blog"
          >
            Blog
          </Link>
          <Link
            className="text-[16px] text-stone-500 font-semibold hover:text-blue-400 max-lg:hidden"
            to="/contact"
          >
            Contact Us
          </Link>
          
        </div>
        <Link to="/englishforcareer">
          <div className="flex justify-end lg:cols-span-1 gap-[60px] mx-auto">
            <button
              style={{
                marginRight: "20px",
                backgroundColor: "rgb(26, 182, 157)",
              }}
              className="text-[16px] text-white font-semibold px-4 py-2 max-lg:hidden rounded hover:bg-[#0260AA]"
            >
              English For Career
            </button>
          </div>
        </Link>

        <div>
          <span
            id="hamgurgerBtn"
            className="lg:hidden pr-10"
            onClick={() => {
              let hiddenSection = document.querySelector("#hamburger");
              hiddenSection.classList.toggle("hidden");
            }}
          >
            <i className="fa-solid fa-bars text-[#0260AA] text-4xl"></i>
          </span>
        </div>
      </div>

      {/* Hamburger section */}
      <div className="hidden" id="hamburger">
        <div
          className="w-full h-full bg-white flex flex-col pr-4 pb-5 gap-10"
          style={{ paddingLeft: "20px" }}
        >
          <Link
            className="text-[16px] mt-5 text-[#0260AA] font-semibold font-ROBOTO"
            to="/"
          >
            Home
          </Link>
          <Link
            className="text-[16px] text-[#0260AA] font-semibold font-ROBOTO"
            to="/"
          >
            Services
          </Link>
          <Link
            className="text-[16px] text-[#0260AA] font-semibold font-ROBOTO"
            to="/"
          >
            Blog
          </Link>
          <Link
            className="text-[16px] text-[#0260AA] font-semibold font-ROBOTO"
            to="/contact"
          >
            Contact Us
          </Link>
          <Link to="/englishforcareer">
            <button
              style={{ backgroundColor: "rgb(26, 182, 157)" }}
              className="text-[16px] text-white font-semibold  px-4 py-2 rounded hover:bg-[#0260AA]"
            >
              English For Career
            </button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Nav;
